import { ProductCategory } from "@utils/constants";

export const getProduct = (
  productType: string | undefined
): ProductCategory => {
  switch (productType) {
    case "diamond":
      return ProductCategory.DIAMOND;
    case "gemstone":
      return ProductCategory.GEMSTONE;
    case "jewelry":
      return ProductCategory.JEWELRY;
    case "lab_grown_diamond":
      return ProductCategory.DIAMOND;
    case "lab_grown_jewelry":
      return ProductCategory.LABGROWN_JEWELRY;
    default:
      return ProductCategory.DEFAULT;
  }
};
